<div class="container">
  <div class="close-button d-flex justify-content-end mb-3">
    <button (click)="activeModal.close()" type="button" class="btn">
      <span class="material-symbols-outlined">
        close
      </span>
    </button>
  </div>
  <p class="title">
    Input the below detail to receive an OTP to your reset password
  </p>

  @if (errorMessage) {
    <div class="error-div mb-3">
      <span>
        {{errorMessage}}
      </span>
    </div>
  }

  <form autocomplete="false" novalidate role="form" [formGroup]="form">
    <div class="form-row">
      <div >
        <div class="input-group">
          <div class="form-floating">
            <input autocomplete="new-password" formControlName="newPassword" placeholder="New Password"
              class="form-control" type="{{hide ? 'password' : 'text'}}">
            <label>New password</label>
          </div>
          <span (click)="hide = !hide" class="input-group-text">
            <span class="material-symbols-outlined">
              {{hide ? 'visibility' : 'visibility_off'}}
            </span>
          </span>
        </div>
      </div>
      <div >
        <div class="input-group">
          <div class="form-floating">
            <input autocomplete="new-password" formControlName="confirmNewPassword" placeholder="Confirm Password"
              class="form-control" type="{{hide ? 'password' : 'text'}}">
            <label>Confirm password</label>
          </div>
          <span (click)="hide = !hide" class="input-group-text">
            <span class="material-symbols-outlined">
              {{hide ? 'visibility' : 'visibility_off'}}
            </span>
          </span>
        </div>
      </div>
    </div>

    <button (click)="onResetPassword()" type="button" class="mx-auto btn prjct-btn mt-5">
      Enter
    </button>
  </form>

</div>
